export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              关于羞羞动漫
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              专注蜜桃动漫在线资源的优质观看平台
            </p>
          </div>

          <div className="bg-background-50 rounded-xl border border-background-200/60 p-6 md:p-8">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              羞羞动漫在线是一个专注于蜜桃动漫在线资源聚合与高清播放的内容平台。我们致力于为广大动漫爱好者提供最全面的羞羞动漫在线观看完整版服务，涵盖校园恋爱、奇幻冒险、新番热映、经典重温等丰富题材，每日更新最新蜜桃动漫在线资源，确保用户体验到流畅、高清、纯净的观看服务。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              本站始终坚持&ldquo;内容为王、体验至上&rdquo;的理念，通过精心整理的专题合集与分类标签体系，帮助用户快速找到心仪的羞羞动漫在线新番与经典作品。所有资源均支持高清播放与移动端适配，让每一次羞羞动漫在线免费观看都成为享受。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              自上线以来，羞羞动漫在线已累计收录蜜桃动漫在线资源超过500部，日均更新多部新番，服务覆盖全国漫迷用户。未来我们将继续扩充资源库、优化播放体验，致力于成为最值得信赖的蜜桃动漫在线观看平台。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}